export default __webpack_public_path__ + "static/media/portrait.1e065751.png";